import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { localEstoqueService } from '../services/localEstoqueService';
import type { SalvarLocalEstoqueRequest } from '../types';

const KEYS = {
  all:   ['locais-estoque'] as const,
  combo: ['locais-estoque', 'combo'] as const,
  lista: (busca?: string) => ['locais-estoque', 'lista', busca] as const,
};

export function useLocalEstoqueCombo() {
  return useQuery({
    queryKey: KEYS.combo,
    queryFn:  () => localEstoqueService.getCombo(),
  });
}

export function useLocaisEstoque(busca?: string) {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: KEYS.lista(busca),
    queryFn:  () => localEstoqueService.listar(busca),
  });

  const criar = useMutation({
    mutationFn: (req: SalvarLocalEstoqueRequest) => localEstoqueService.criar(req),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });

  const atualizar = useMutation({
    mutationFn: ({ id, req }: { id: number; req: SalvarLocalEstoqueRequest }) =>
      localEstoqueService.atualizar(id, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });

  const excluir = useMutation({
    mutationFn: (id: number) => localEstoqueService.excluir(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEYS.all }),
  });

  return { query, criar, atualizar, excluir };
}
